import { render } from "./input_credit_add_account.vue?vue&type=template&id=2b5f63f6&scoped=true"
import script from "./input_credit_add_account.vue?vue&type=script&lang=js"
export * from "./input_credit_add_account.vue?vue&type=script&lang=js"

import "./input_credit_add_account.vue?vue&type=style&index=0&id=2b5f63f6&scoped=true&lang=css"

import exportComponent from "/home/hkohashi/webinar-master-php83/frontend-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b5f63f6"]])

export default __exports__